var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom",
            trigger: "hover",
            width: "300",
            "popper-class": "remark-pop",
            "visible-arrow": false,
          },
        },
        [
          _c("div", {
            staticClass: "remark-style",
            style: { backgroundColor: _vm.remarkCfg.bgFill },
            domProps: { innerHTML: _vm._s(_vm.remarkCfg.content) },
          }),
          _c("i", {
            staticClass: "el-icon-info",
            staticStyle: {
              cursor: "pointer",
              color: "gray",
              "font-size": "12px",
            },
            attrs: { slot: "reference" },
            slot: "reference",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }